import { Pipe, PipeTransform } from '@angular/core';

// Filtro SIN paso de parámetros.
@Pipe({
    name: 'filterFunction',
    pure: true // true es el valor por defecto para este atributo.
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], callback: (element: any) => boolean): any {
        if (!items || !callback) {
            return items;
        }
        return items.filter(item => callback(item));
    } // End Transform
} // End class FilterPipe

// Filtro CON paso de parámetros.
@Pipe({
    name: 'filterParamFunction',
    // pure: false // Se ejecuta en cada ciclo de cada componente.
    pure: true // Se ejecuta sólo cuando se detecta un cambio en el valor de entrada
               // (primitivos y referencias a objetos, no detecta cambios propiedades de objetos.).
})
export class FilterParamPipe implements PipeTransform {

    transform(items: any, arg: any, callback: (element: any, aux: any) => boolean): any {

        console.log('---> FilterParamPipe transform:');
        console.log(arg);

        if (!items || !callback) {
            return items;
        }
        return items.filter(item => callback(item, arg));
    } // End Transform
} // End class FilterParamPipe

@Pipe({
  name: 'writeDimension',
  pure: true
})
export class WriteDimensionPipe implements PipeTransform {
  transform(compositionIn: any, args1: any, args2: any): any {
    // console.log(' writeDimension Unidad: ' + compositionIn.unit_id);
    // console.log(compositionIn);
    // console.log(args1);
    // console.log(args2);

    let dimensionString = '';

    if (compositionIn.unit_id === 'm2') {

      // console.log(' Unidad = m2');

      if (compositionIn.element_type === 1) {
        dimensionString = compositionIn.stockwidth + ' x ' + compositionIn.stockheight + ' mm';
      } else {
        dimensionString = ((compositionIn.stockwidth * compositionIn.stockheight) / 1000000).toFixed(2) + ' m2';
      }
    } else if (compositionIn.unit_id === 'ml') {
      // console.log(' Unidad = ml');
      dimensionString = (2 * (compositionIn.stockwidth + compositionIn.stockheight) / 1000) + ' ml';
    } else if (compositionIn.unit_id === 'm2*mm') {
      // console.log(' Unidad = m2*mm');
      dimensionString = ((compositionIn.stockwidth * compositionIn.stockheight) / 1000000).toFixed(2)
                          + ' m2 x ' + compositionIn.stocklength + ' mm';
    } else if (compositionIn.unit_id === 'mm') {
      // console.log(' Unidad = mm');
      dimensionString = compositionIn.stocklength + ' mm';
    } else if (compositionIn.unit_id === '%') { // tanto por ciento '%'
      dimensionString = compositionIn.surcharge + '%';

    } else { // unidades 'uds'
      // console.log(' Unidad = uds');
      // Se pone sólo la etiqueta de "unidad" porque al coincidir con
      // la cantidad, cuaya columna va al lado, y se vería duplicado.
      dimensionString = 'uds'; // compositionIn.unit + ' uds';
    }

    return dimensionString;

  } // End Transform
} // End class WriteDimensionPipe


@Pipe({
  name: 'levelAnid',
  pure: true
})
export class levelAnidPipe implements PipeTransform {
  transform(parentIn: any, args?: any): any {
    // console.log('->> levelAnidPipe: ');
    // console.log(item);
    // console.log(args);

    let deep  = 0;

    if (parentIn !== null && parentIn !== undefined) {
      deep = parentIn.split(',').length - 1;
    }
    return deep;

  } // End Transform
} // End class levelAnidPipe

@Pipe({
  name: 'localLevelAnid',
  pure: true
})
export class localLevelAnidPipe implements PipeTransform {
  transform(parentIn: any, args?: any): any {
    // console.log('->> localLevelAnidPipe: ');
    // console.log(item);
    // console.log(args);

    let deep  = 0;

    if (parentIn !== null && parentIn !== undefined) {
      deep = parentIn.split(',').length - args - 1;
    }
    return deep;
  } // End Transform
} // End class localLevelAnidPipe

